import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { createQuizSubmission } from "../../../api/endpoints/QuestionEndpoints";
import { QuizSubmissionRequest } from "../../../models/QuizSubmission";

export default function useCreateQuizSubmission(quizId: string) {
  return useMutation<void, AxiosError, { submission: QuizSubmissionRequest }>({
    mutationKey: ["create-submission", quizId],
    mutationFn: ({ submission }) => createQuizSubmission(quizId, submission),
  });
}
